import type { FeedbackState } from '../../../types/feedback';
import { getLegendItems, type TimeSection } from './feedbackUtils';

interface FloatingLegendProps {
    feedbackStates: FeedbackState[];
    timeSections: TimeSection[];
}

export const FloatingLegend = ({ feedbackStates, timeSections }: FloatingLegendProps) => {
    const legendItems = getLegendItems(feedbackStates);

    return (
        <div className="grid gap-4 sm:grid-cols-2 lg:block mb-6 lg:mb-0">
            {/* Section Totals */}
            <div className="bg-white border border-gray-200 rounded-lg shadow-lg p-3 lg:fixed lg:top-20 lg:right-4 lg:z-40 lg:min-w-[180px]">
                <h4 className="text-sm font-semibold text-gray-900 mb-2 border-b border-gray-100 pb-1.5">Section Totals</h4>
                <div className="space-y-1.5">
                    {timeSections.map((section, index) => (
                        <div key={index} className="flex items-center justify-between gap-3">
                            <span className="text-xs text-gray-700">{section.title}</span>
                            <span className="text-xs font-semibold text-gray-900 bg-blue-50 text-blue-700 px-2 py-0.5 rounded">
                                {section.states.length}
                            </span>
                        </div>
                    ))}
                    <div className="flex items-center justify-between gap-3 pt-1.5 border-t border-gray-100 mt-2">
                        <span className="text-xs font-semibold text-gray-900">Total</span>
                        <span className="text-xs font-bold text-gray-900 bg-gray-100 px-2 py-0.5 rounded">
                            {feedbackStates.length}
                        </span>
                    </div>
                </div>
            </div>

            {/* Action Types */}
            <div className="bg-white border border-gray-200 rounded-lg shadow-lg p-3 lg:fixed lg:bottom-4 lg:right-4 lg:z-40 lg:max-w-xs">
                <h4 className="text-sm font-semibold text-gray-900 mb-2">Action Types</h4>
                <div className="space-y-1.5">
                    {legendItems.map((item) => (
                        <div key={item.key} className="flex items-center justify-between gap-2">
                            <div className="flex items-center gap-2">
                                <div className="flex-shrink-0">
                                    {item.icon}
                                </div>
                                <span className="text-xs text-gray-700">{item.label}</span>
                            </div>
                            <span className="text-xs font-semibold text-gray-900 bg-gray-100 px-1.5 py-0.5 rounded">
                                {item.total}
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

